import React, { useRef, useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import useGlobalState, { g_user, API_Root } from '../../globalState';
import { MyTrip } from './MyTrip';

export const MyTrips = () => {
   const [trips, setTrips] = useState([]);
   const [loading, setLoading] = useState(true);
   const [lastUpdated, setLastUpdated] = useState(null);
   const [user,] = useGlobalState(g_user);
   const toast = useRef(null);
   const history = useHistory();

   const getMyTrips = (isManual) => {
      if (!user?.user?.id) {
         return;
      }
      var apiUrl = `${API_Root}api/trip/GetCurrentTripsForUser?userId=${user.user.id}`;
      axios.get(apiUrl).then((values) => {
         const all = values.data || [];
         const assigned = all.filter((t) =>
            t.TripVehicles?.some((v) => v.porterId == user.user.id)
         );
         setTrips(assigned);
         setLastUpdated(new Date());
         setLoading(false);
         if (isManual) {
            toast.current?.show({
               severity: 'success',
               summary: 'List updated',
               detail: assigned.length === 1 ? '1 trip' : `${assigned.length} trips`,
               life: 2000
            });
         }
      }).catch(() => {
         setLoading(false);
         toast.current?.show({
            severity: 'error',
            summary: 'Could not load trips',
            detail: 'Please try refresh.',
            life: 4000
         });
      });
   };

   useEffect(() => {
      getMyTrips(false);
      const interval = setInterval(() => {
         getMyTrips(false);
      }, 60000);
      return () => clearInterval(interval);
   }, [user?.user?.id]);

   const formatUpdated = () => {
      if (!lastUpdated) {
         return '';
      }
      return lastUpdated.toLocaleTimeString('en-US', {
         hour: 'numeric',
         minute: '2-digit'
      });
   };

   const countLabel = trips.length === 1 ? '1 assigned trip' : `${trips.length} assigned trips`;

   return (
      <>
         <Toast ref={toast} />
         <div className="jobs-page">
            <div className="jobs-page-header">
               <div>
                  <h2 className="jobs-page-title">My Trips</h2>
                  <p className="jobs-page-meta">
                     {loading ? 'Loading your trips…' : countLabel}
                     {lastUpdated && !loading ? ` · Updated ${formatUpdated()}` : ''}
                  </p>
               </div>
               <Button
                  label="Refresh"
                  icon="pi pi-refresh"
                  onClick={() => getMyTrips(true)}
                  disabled={loading}
               />
            </div>

            {loading && trips.length === 0 && (
               <div className="jobs-empty">
                  <i className="pi pi-spin pi-spinner text-3xl mb-3"></i>
                  <p>Loading your trips…</p>
               </div>
            )}

            {!loading && trips.length === 0 && (
               <div className="jobs-empty">
                  <i className="pi pi-map text-5xl mb-3"></i>
                  <h3>No assigned trips right now</h3>
                  <p>Claim a trip order when one is available, or wait for a dispatcher to assign you.</p>
                  <Button
                     className="mt-3"
                     label="View trip orders"
                     icon="pi pi-car"
                     onClick={() => history.push('/available-trips')}
                  />
               </div>
            )}

            {trips.length > 0 && (
               <div className="jobs-list">
                  {trips.map((item) => (
                     <MyTrip
                        key={item.id}
                        trip={item}
                        userId={user.user.id}
                        onOpen={(vehicleId) => history.push(vehicleId ? `/my-trips/${item.id}?vehicleId=${vehicleId}` : `/my-trips/${item.id}`)}
                     />
                  ))}
               </div>
            )}
         </div>
      </>
   );
};
